import { Link } from 'react-router-dom';
import type { Id } from '../../convex/_generated/dataModel';

export function PlayerLink({
  playerId,
  name,
  position,
  nflTeam,
}: {
  playerId: Id<'players'>;
  name: string;
  position?: string;
  nflTeam?: string;
}): JSX.Element {
  return (
    <Link to={`/history/players/${playerId}`} className="hover:underline">
      {name}
      {(position || nflTeam) && (
        <span className="text-xs text-gray-500 ml-1">
          ({[position, nflTeam].filter(Boolean).join(' · ')})
        </span>
      )}
    </Link>
  );
}
